import React, { useCallback } from "react";
import { useSelector } from 'react-redux';
import { useResizeDetector } from "react-resize-detector";
import { selectMessage } from "../../../../../util/store/selectors";
import Conversation from "./Conversation";
import { ConversationProvider } from './ConversationContext';
import ConversationAdd from "./ConverstationAdd";
import styles from './style.module.scss';

interface IProps {
}

const Conversations: React.FC<IProps> = (props) => {
    const conversations = useSelector(selectMessage.conversations);

    const handleResize = useCallback(() => {
    }, [])

    const { ref } = useResizeDetector({
        handleHeight: false,
        refreshMode: 'debounce',
        refreshRate: 1000,
        onResize: () => handleResize
    });

    return <div ref={ref} className={styles.wrapper}>
        <ConversationAdd />
        {conversations.map(item => <ConversationProvider key={item.id}>
            <Conversation  {...item} />
        </ConversationProvider>)}
    </div>
};

export default Conversations;
